import { render } from "./KanbanBoard.vue?vue&type=template&id=b4562ce0&scoped=true&ts=true"
import script from "./KanbanBoard.vue?vue&type=script&lang=ts"
export * from "./KanbanBoard.vue?vue&type=script&lang=ts"

import "./KanbanBoard.vue?vue&type=style&index=0&id=b4562ce0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4562ce0"]])

export default __exports__